module.exports = __webpack_public_path__ + "img/20210906-1630911127584799.f373c04c.jpg";